/**
 * Открывает внешнюю ссылку, не выкидывая пользователя из мини-аппа.
 *
 * `window.open` и `location.href` в webview Telegram уводят в системный
 * браузер: на iOS поверх приложения встаёт Safari, и вернуться назад можно
 * только руками. `WebApp.openLink` открывает встроенный браузер Telegram —
 * мини-апп остаётся жив и получает управление обратно, как только страницу
 * закроют. Для оплаты это принципиально: пользователь должен вернуться в
 * корзину сам, а не искать вкладку в другом приложении.
 */
export const openExternalLink = (url: string) => {
  const webApp = window.Telegram?.WebApp;

  if (!webApp?.openLink) {
    // Обычный браузер: локальная разработка или мини-апп открыт вне Telegram.
    window.open(url, '_blank', 'noopener');
    return;
  }

  // Ссылки на сам Telegram умеет только openTelegramLink — openLink показал бы
  // веб-страницу-заглушку t.me вместо перехода в приложение.
  if (/^https?:\/\/t\.me\//i.test(url)) {
    webApp.openTelegramLink(url);
    return;
  }

  webApp.openLink(url);
};
